import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home'
import About from './pages/About'
import Contact from './pages/Contact'
import './App.css';
import Header from './components/Header';
import ServiceComponent from './components/ServiceComponent';
import Footer from './components/Footer';
import FranchiseDevelopment from './pages/FranchiseDevelopment';
import ClientPortfolio from './pages/ClientPortfolio';
import AdvisoryServices from './pages/AdvisoryServices';
import BrandSolutions from './pages/BrandSolutions';
import ExperientialMarketing from './pages/ExperientialMarketing';
import Login from './pages/Login';

function App() {

  const {pathname} = useLocation();

  return (
    <div>
      {pathname!= '/admin/login' && <Header/>}
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/service/:endpoints' element={<ServiceComponent/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/brand' element={<BrandSolutions/>}/>
        <Route path='/experiential' element={<ExperientialMarketing/>}/>
        <Route path='/franchise' element={<FranchiseDevelopment/>}/>
        {/* <Route path='/client' element={<ClientPortfolio/>}/> */}
        <Route path='/advisory' element={<AdvisoryServices/>}/>
        {/* <Route path='/partners' element={<Partners/>}/> */}
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/admin/login' element={<Login/>}/>
      </Routes>
      {pathname!= '/admin/login' && <Footer/>}
    </div>
  );
}

export default App;
